import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of, Subject,  } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { SimpleReponseResult } from '../Models/SimpleReponseResult';
import { InputCheckersService } from './input-checkers.service';
import { catchError, map, tap } from 'rxjs/operators';
import { SharedDataService } from './shared-data/shared-data.service';
import { 
  PS_Get_Buttons_Result, 
  ChangeStatutParams, 
  GetCompanyByVatParameters,
  SupplierMail,CreditSafeData,
  PS_Relance_Doc_Result,
  Question,
  PS_Search_Suppliers_Result,
  ApeCod,
  SupplierStatut,
  Agency,
  SupplierDescriptif,
  SupplierAccountParameters,
  SupplierKnowledgeParameters,
  SearchSuppliersParameters,
  SupplierContact,
  ExtUser,
  Supplier,
  SupplierWF,
  SupplierWfAndContact,
  SupplierPurchaseComment,
  SuiviAchatsUpdateParameters,
  InseeEtablissement,
  PS_Indicateurs_Result,
  PS_PAF_LISTE_EVF_ECF_RAI_Result,
  SupplierPilotageDepens,
  DuplicateSupplierParameters,
  SendRegulDocsMailsParameters,
  SupplierRseAnswersIndex,
  SupplierAgency,
  SupplierAnswer,
  Address,
  SupplierFamily,
  SupplierUpdateComment,
  SupplierPerimeter,
  Currency,
  FT_SupplierFinancialStatements_Result
 } from '../all-models';
import { KeyValue } from '@angular/common';
import { SupplierAccHisto } from '../Models/SupplierAccHisto';
import { SupplierRseAnswer } from '../Models/SupplierRseAnswer';
import { SupplierInseeDataExtend } from '../Models/SupplierInseeDataExtend';


@Injectable({
  providedIn: 'root'
})
export class SuppliersService {
  SuppliersUrl: string ;
  constructor(
    private http: HttpClient,    
    private intputCheckersSvc : InputCheckersService,
    public sharedDataSvc: SharedDataService) {
      this.SuppliersUrl = this.sharedDataSvc.apiBaseUrl + 'Suppliers';
     }
    

  get lstStatut(): SupplierStatut[]{
    return this.sharedDataSvc.supplierStatuts;
  };
  
  get lstApeCods(): ApeCod[] {
    return this.sharedDataSvc.lstApeCods;
  }
  get msgSiretEtablissementInactif(): string {
    return this.sharedDataSvc.getLoadedLabel('Msg_SIRET_Etablissement_Inactif');
  }

    
  getAllSuppliers(): Observable<Supplier[]> {
    return this.http.get<Supplier[]>(this.SuppliersUrl);
  }

  getSupplier(supplierId: number): Observable<Supplier> {
    if (supplierId) this.sharedDataSvc.WindowLock(this.sharedDataSvc.lngCod=='EN' ? 'Loading supplier datas' : 'Chargement des données du fournisseur en cours...');
    return this.http.get<Supplier>(`${this.SuppliersUrl}/${supplierId}`)
      .pipe(
          map(
            results=>{
              let supplier:Supplier = results;
              if (supplier) {
                if (!supplier.PayCurId){
                  supplier.PayCurId = this.sharedDataSvc.defaultCurrency?.Id;
                }
                supplier.PayCurrency = this.sharedDataSvc.currencies.find(c=>c.Id==supplier.PayCurId) || null;
                supplier.OrderCurId = supplier.PayCurId;
                supplier.OrderCurrency = supplier.PayCurrency;
                
              }
              return supplier;
            }
          ),
        tap(() => this.sharedDataSvc.WindowUnlock()),
        catchError(err => {
          this.sharedDataSvc.alertSubscriptionReject(err);
          throw err;
        })
      );    
  }

  getSupplier_old(supplierId: number): Observable<Supplier> {
    if (supplierId) this.sharedDataSvc.WindowLock(this.sharedDataSvc.lngCod=='EN' ? 'Loading supplier datas' : 'Chargement des données du fournisseur en cours...');
    return forkJoin([
          this.http.get<Supplier>(`${this.SuppliersUrl}/${supplierId}/noVirtualChild`),
          this.getSupplierExtend1(supplierId),
          this.getSupplierExtend2(supplierId),
        ])
        .pipe(
          map(
            results=>{
              let supplier:Supplier = results[0];
              let extend1:[SupplierContact[], SupplierAgency[], SupplierAnswer[], SupplierRseAnswer[],SupplierFamily[], Address] = results[1];
              let extend2:[SupplierUpdateComment[],SupplierPerimeter[],SupplierPurchaseComment[]] = results[2];
              supplier.SupplierContacts = extend1[0];
              supplier.SupplierAgencies = extend1[1];
              supplier.SupplierAnswers = extend1[2];
              supplier.SupplierRseAnswers = extend1[3];
              supplier.SupplierFamilies = extend1[4];
              supplier.FacAddress = extend1[5];
              supplier.SupplierUpdateComments = extend2[0];
              supplier.SupplierPerimeters = extend2[1];
              supplier.SupplierPurchaseComments = extend2[2];
              this.sharedDataSvc.WindowUnlock();
              return supplier;
            }
          ),
          switchMap((supplier:Supplier)=>{
              this.GetSupplierInseeEtablissement(supplier,true, false).subscribe({
                next:(inseeEtab:InseeEtablissement)=> {
                  supplier.Etablissement = inseeEtab;
                   this.rejectIfSiretInactif(supplier).then(result=>{
                    if (!result.Ok){ throw new Error(result.Message || ''); }
                  });              
                }
              });              
              return of(supplier);
          }),
          catchError(err => {
            this.sharedDataSvc.alertSubscriptionReject(err);
            throw err;
          })
        );
  }

  private getSupplierExtend1(supplierId:number):Observable<[SupplierContact[], SupplierAgency[], SupplierAnswer[], SupplierRseAnswer[],SupplierFamily[], Address]> {
    return forkJoin([
      this.http.get<SupplierContact[]>(`${this.SuppliersUrl}/${supplierId}/SupplierContacts`),
      this.http.get<SupplierAgency[]>(`${this.SuppliersUrl}/${supplierId}/SupplierAgencies`),
      this.http.get<SupplierAnswer[]>(`${this.SuppliersUrl}/${supplierId}/SupplierAnswers`),
      this.http.get<SupplierRseAnswer[]>(`${this.SuppliersUrl}/${supplierId}/SupplierRseAnswers`),
      this.http.get<SupplierFamily[]>(`${this.SuppliersUrl}/${supplierId}/SupplierFamilies`),
      this.http.get<Address>(`${this.SuppliersUrl}/${supplierId}/SupplierFacAddress`),
    ]);
  }

  private getSupplierExtend2(supplierId:number):Observable<[SupplierUpdateComment[],SupplierPerimeter[],SupplierPurchaseComment[]]> {
    return forkJoin([
      this.http.get<SupplierUpdateComment[]>(`${this.SuppliersUrl}/${supplierId}/SupplierUpdateComments`),
      this.http.get<SupplierPerimeter[]>(`${this.SuppliersUrl}/${supplierId}/SupplierPerimeters`),
      this.http.get<SupplierPurchaseComment[]>(`${this.SuppliersUrl}/${supplierId}/SupplierPurchaseComments`),
      //this.InseeDatas(supplierId)
    ]);
  }

  postSupplier(supplier: Supplier) : Observable<Supplier> {
    return this.http.post<Supplier>(this.SuppliersUrl,supplier);
  }


  putSupplier(supplier: Supplier) : void {
    this.http.put<Supplier>(this.SuppliersUrl,supplier);
  }

  DeleteSupplier(supplier: Supplier) : Observable<SimpleReponseResult> {
   return  this.http.delete<SimpleReponseResult>(`${this.SuppliersUrl}/${supplier.Id}`);
  }

  private _deletedSupplierSubject:Subject<number>=new Subject<number>();
  public onSupplierDeleted:Observable<number> = this._deletedSupplierSubject.asObservable();
  raiseSupplierDeleted(supplierId:number):void{
    this._deletedSupplierSubject.next(supplierId);
  }
  
  //Attention: NewSupplier n'est pas dans le même controleur d'api pour ne pas être bloqué par le contrôle d'authorisation
  getNewExtUser(id: number): Observable<ExtUser> {
    return this.http.get<ExtUser>(`${this.sharedDataSvc.apiBaseUrl}/NewUser/${id}`);
  }

  getSupplierContacts(supplierId: number): Observable<SupplierContact[]> {
    return this.http.get<SupplierContact[]>(`${this.SuppliersUrl}/${supplierId}/Contacts`);
  }

  addContact(supplierId:number, contactId:number, createAccount:number): Observable<SupplierContact>{
    if (!createAccount) createAccount = 0;
    return this.http.post<SupplierContact>(`${this.SuppliersUrl}/${supplierId}/Contacts/Add/${contactId}/${createAccount}`,null);
  }
  addContactAsReferent(supplierId:number, contactId:number): Observable<SupplierContact>{
    return this.http.post<SupplierContact>(`${this.SuppliersUrl}/${supplierId}/Contacts/AddReferent/${contactId}`,null);
  }

  addContacts(supplierId:number, supplierContacts: SupplierContact[]): Observable<SupplierContact[]>{
    if (!supplierContacts) return of([]);
    supplierContacts.forEach(sc=>{
      if (sc.IsReferent == null) sc.IsReferent=0;
      if (sc.CreateAccount == null) sc.CreateAccount=0;
    })
    return this.http.post<SupplierContact[]>(`${this.SuppliersUrl}/${supplierId}/Suppliers/AddContacts`,supplierContacts);
  }

  removeContact(supplierId:number, contactId:number): Observable<SimpleReponseResult>{
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/Contacts/Remove/${contactId}`,null);
  }

  removeContacts(supplierId:number, contactIds:number[]): Observable<SimpleReponseResult>{
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/Contacts/RemoveMultiple`,contactIds);
  }
  setContactReferent(supplierId:number, contactId:number): Observable<SimpleReponseResult>{
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/Contacts/SetReferent/${contactId}`,null);
  }

  public InseeDatas(supplierId:number,reload:boolean=false):Observable<SupplierInseeDataExtend> {
    this.sharedDataSvc.apiSirenLastError = null;
    return this.http.get<SupplierInseeDataExtend>(`${this.SuppliersUrl}/${supplierId}/InseeDatas${reload?'/reload':''}`)
    .pipe(map((result:any) => {
      this.sharedDataSvc.apiSirenLastError = result?.Message;
      return result;
    }));
  }
  
  public getSuppliers(parameters: SearchSuppliersParameters):Observable<PS_Search_Suppliers_Result[]> {
    return this.http.post<PS_Search_Suppliers_Result[]>(`${this.SuppliersUrl}/SearchSuppliers`,parameters);
  }

  public getLoggedExtUserSuppliers():Observable<Supplier[]> {
    return this.http.get<Supplier[]>(this.sharedDataSvc.apiBaseUrl + "ExtUsers/loggedUser/Suppliers");
  }

  
  public reloadContacts(supplier: Supplier) : Observable<SupplierContact[]> {
    if (supplier && supplier.Id) {
      return this.getSupplierContacts(supplier.Id)
        .pipe(tap((scs:SupplierContact[])=>{
           supplier.SupplierContacts = scs;
        }));
    } else {
      return of([]);
    }
  }
  //Mise à jour du descriptif d'un fournisseur
  public patchSupplierDescriptif(id: number, parameters : SupplierDescriptif): Observable<SimpleReponseResult> {
    return this.http.patch<SimpleReponseResult>(`${this.SuppliersUrl}/${id}/Descriptif`,parameters);
  }
  //Mise à jour du descriptif d'un fournisseur
  public patchSupplierAccount(id: number, parameters : SupplierAccountParameters): Observable<SimpleReponseResult> {
    return this.http.patch<SimpleReponseResult>(`${this.SuppliersUrl}/${id}/Account`,parameters);
  }

  //Mise à jour du savoir faire d'un fournisseur
  public patchSupplierKnowledge(id: number, parameters : SupplierKnowledgeParameters): Observable<SimpleReponseResult> {
    return this.http.patch<SimpleReponseResult>(`${this.SuppliersUrl}/${id}/Knowledge`,parameters);
  }

  public bindInseeEtablissementToSupplier( supplier:Supplier, etab: InseeEtablissement, updateSignaletique : boolean = true): SimpleReponseResult {
    let retour : SimpleReponseResult = new SimpleReponseResult();
    retour.Ok = true;
    retour.Message = null;  
    let agency : Agency = supplier.SupplierAgencies?.find(sa=>sa.IsSupplierAgency==1)?.Agency;
    if (etab?.uniteLegale?.etatAdministratifUniteLegale != 'A') {
      retour.Ok = false;
      retour.Message = this.msgSiretEtablissementInactif;
      return retour;
    }
    
    if (updateSignaletique) supplier.SupplierName = (etab.uniteLegale?.denominationUniteLegale ||'').substring(0,80);
    supplier.TvaIntra = etab.vat;
    if (supplier && etab) {
      supplier.Etablissement = etab;
    }
    if (etab && agency && updateSignaletique) {
      const adr = etab.adresseEtablissement;
      if (adr) {
        agency.Address.AddrNum = (adr.numeroVoieEtablissement||'') + (adr.indiceRepetitionEtablissement||'');
        agency.Address.Addr1 = ((adr.typeVoieEtablissement||'')+ ' '+ adr.libelleVoieEtablissement).trim();
        agency.Address.Addr2 = (adr.complementAdresseEtablissement||'');
        agency.Address.PostalCod = (adr.codePostalEtablissement||'');
        agency.Address.City = (adr.libelleCommuneEtablissement||adr.libelleCommuneEtrangerEtablissement||'');
      }
    }
    if ( (etab?.uniteLegale?.activitePrincipaleUniteLegale||'null')!='null'){
      let apeCod : ApeCod = this.lstApeCods.find(a=>a.Cod==etab?.uniteLegale?.activitePrincipaleUniteLegale.replace('.',''));
      if (apeCod) {
        supplier.ApeId = apeCod.Id;
        supplier.ApeCod = apeCod;
      }
    }
    //Si le siret du fournisseur!= Siret du siege, on met le siret du siège dans le champ prévu à cet effet
    if (etab && !etab.etablissementSiege) {
      supplier.HQSiret = etab.siren+etab.uniteLegale?.nicSiegeUniteLegale;
    } else {
      supplier.HQSiret = null;
    }
    return retour;
  }

  PatchSimpleValues(id:number,supplierPatch: Supplier, propertyName:string=''): Observable<SimpleReponseResult>{
    let parameters: any = {};
    Object.keys(supplierPatch).forEach(key => {
      let item:any = (<any>supplierPatch)[key];
      if (item != null && ! Array.isArray(item)){
        if (item === ''){
          parameters[key]="''";
        } else if (item || key.toLowerCase()==propertyName.toLowerCase()) {
          parameters[key]=item;
        }        
      }
    });
    this.sharedDataSvc.WindowLock();
    return this.http.patch<SimpleReponseResult>(`${this.SuppliersUrl}/${id}/PatchSimpleValues`,parameters)
    .pipe(map((result:SimpleReponseResult) => {
        this.sharedDataSvc.WindowUnlock();
        if (!result.Ok && !!result.Message) {
          throw new Error(result.Message);
        }
        return result;
      }));
  }

  PostChangeStatut(supplierId:number,param : ChangeStatutParams): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/ChangeStatut`,param);
  }

  ChangeStatut(id:number, currentStatutId:number,newStatutId: number, mailsModelCod: string = '', WFMotifId: number = null, comments:string=null): Observable<SimpleReponseResult> {
    let param : ChangeStatutParams = new ChangeStatutParams();
    param.SupplierId = id;
    param.CurrentStatutId=currentStatutId;
    param.NewStatutId = newStatutId;
    param.MailModelCod = mailsModelCod;
    param.WFMotifId = WFMotifId;
    param.Comments=comments
    return this.PostChangeStatut(id,param);
  }

  ChangeStatutByCod(id:number, currentStatutId:number,statutCod:string, mailsModelCod: string = '', WFMotifId: number = null, comments:string=null): Observable<SimpleReponseResult>{
    const newStatut:SupplierStatut = this.lstStatut.find(item=>item.Cod==statutCod);
    return this.ChangeStatut(id, currentStatutId,newStatut?.Id ||0,mailsModelCod,WFMotifId,comments);
  }

  supplierStatut(supplier:Supplier):SupplierStatut{
    if (!supplier) return null;
    return this.lstStatut.find(s=>s.Id==supplier?.StatutId);
  }

  public StatutCss(statutId:number):string {
    let cssRet: string;
    const statut: SupplierStatut = this.lstStatut.find(s=>s.Id==statutId);
    if (statut) {
      if (this.sharedDataSvc.portalType == 'EXTRANET') {
        cssRet = statut.BtnClassExtranet;
      } else {
        cssRet = statut.BtnClass;
      }
    }
    return (cssRet || 'primary');
  }
  
  public SupplierStatutCss(supplierStatutId:number):string {
    const statut:SupplierStatut = this.lstStatut.find(s=>s.Id==supplierStatutId);
    return this.StatutCss(statut?.Id);    
  }


  

  getExtUser(supplierId: number):Observable<ExtUser>{
    return this.http.get<ExtUser>(`${this.SuppliersUrl}/${supplierId}/ExtUser`);
  }
  
  CanChangeStatut(supplierId: number):Observable<boolean>{
    return this.http.get<boolean>(`${this.SuppliersUrl}/${supplierId}/CanChangeStatut`);
  }
  postVisibleQuestions(supplierId: number, selectedFamiliesId: number[]):Observable<Question[]>{
    return this.http.post<Question[]>(`${this.SuppliersUrl}/${supplierId}/VisibleQuestions`,selectedFamiliesId);
  }

  CreatePendingAccounts(supplierId:number):Observable<SimpleReponseResult>{
    return  this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/CreatePendingAccounts`,null);
  }

  postSupplierValidation(supplierId:number):Observable<SimpleReponseResult>{
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/SupplierValidation`,null);
  }

  GetAllWorkFlow(supplierId:number):Observable<SupplierWfAndContact[]>{
    return this.http.get<SupplierWfAndContact[]>(`${this.SuppliersUrl}/${supplierId}/GetAllWorkFlow`);
  }

  GetCurrentWorkFlow(supplierId:number):Observable<SupplierWF>{
    return this.http.get<SupplierWF>(`${this.SuppliersUrl}/${supplierId}/GetCurrentWorkFlow`);
  }

  GetPreviousWorkFlow(supplierId:number):Observable<SupplierWF>{
    return this.http.get<SupplierWF>(`${this.SuppliersUrl}/${supplierId}/GetPreviousWorkFlow`);
  }

  GetButtons(supplierId:number):Observable<PS_Get_Buttons_Result[]>{
    return this.http.get<PS_Get_Buttons_Result[]>(`${this.SuppliersUrl}/${supplierId}/GetButtons`);
  }

  SupplierComplement(supplierId:number):Observable<SimpleReponseResult>{
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/SupplierComplement`,null);
  }
  UpdateCreditSafeDatas(supplierId:number,parameters:GetCompanyByVatParameters):Observable<SimpleReponseResult>{
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/UpdateCreditSafeDatas`,parameters);
  }

  GetCreditSafeDatas(supplierId:number):Observable<CreditSafeData>{
    return this.http.get<CreditSafeData>(`${this.SuppliersUrl}/${supplierId}/CreditSafeDatas`);
  }

  FinancialStatements(supplierId:number):Observable<FT_SupplierFinancialStatements_Result[]>{
    return this.http.get<FT_SupplierFinancialStatements_Result[]>(`${this.SuppliersUrl}/${supplierId}/FinancialStatements`);
  }

  GetWorkflowMails(supplierId:number,workflowId:number):Observable<SupplierMail[]>{
    return this.http.get<SupplierMail[]>(`${this.SuppliersUrl}/${supplierId}/Workflow/${workflowId}/mails`);
  }

  GetSupplierMails(supplierId:number):Observable<SupplierMail[]>{
    return this.http.get<SupplierMail[]>(`${this.SuppliersUrl}/${supplierId}/mails`);
  }

  PostUpdateComment(supplierId: number, comment:string):Observable<SimpleReponseResult>{
    let parameters: any = {'comment':comment};
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/UpdateComment`,parameters);
  }

  PostChangeCountry(supplierId: number, countryId:number): Observable<SimpleReponseResult>{
     return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/ChangeCountry`,countryId);
  }
  PostRelanceDocuments(supplierId:number):Observable<SimpleReponseResult>{
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/RelanceDocuments`,null);    
  }
  
  GetRelanceDocList(supplierId:number):Observable<PS_Relance_Doc_Result[]>{
    return this.http.get<PS_Relance_Doc_Result[]>(`${this.SuppliersUrl}/${supplierId}/RelanceDocList`);
  }
  get canCreateSupplier(): boolean {
    return ['ADMIN', 'ACH_FAMHA', 'ACH_OPERAT', 'ACH_OPERAT_2', 'DEMANDEUR'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0;
  }
  
  GetIndicateurs(supplierId:number):Observable<PS_Indicateurs_Result[]>{
    return this.http.get<PS_Indicateurs_Result[]>(`${this.SuppliersUrl}/${supplierId}/Indicateurs`);
  }
  
  GetMoovAppsEvfs(supplierId:number):Observable<PS_PAF_LISTE_EVF_ECF_RAI_Result[]>{
    return this.http.get<PS_PAF_LISTE_EVF_ECF_RAI_Result[]>(`${this.SuppliersUrl}/${supplierId}/MoovAppsEvfs`);    
  }

  PostUpdateQualityFlag(supplierId: number,flagId:number, flagComments: string): Observable<SimpleReponseResult> {
    let parameters: KeyValue<number,string>
      = {
          key:flagId,
          value:flagComments
        };
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/UpdateQualityFlag`,parameters);
  }

  // Renvoie True si le fournisseur est dans un flux de validation de WorkFlow et que le profil connecté peut valider ce worflow
  canValidateWFSupplier(supplier:Supplier): boolean {
    let supplierStatut:SupplierStatut = this.sharedDataSvc.supplierStatuts.find(st=>st.Id==supplier?.StatutId);
    let statut:string=supplierStatut?.Cod;
    if (this.sharedDataSvc.profil?.Cod=='ADMIN'){
      return true;
    } else if ( ['DEMANDEUR', 'ACH_OPERAT_2'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0){
      return (statut>='010' && statut<='100');
    } else if ( ['ACH_OPERAT'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0){
      return (statut>='010' && statut<'300' && statut!='150' && statut!='200');
    } else if (this.sharedDataSvc.profil?.Cod=='ACH_FAMHA'){
      return (statut>='250' && statut<'400' && statut!='300');
    } else if (this.sharedDataSvc.profil?.Cod=='CTRL_QUAL'){
      return (statut>='450' && statut<'500');
    } else if (this.sharedDataSvc.profil?.Cod=='COMPTA'){
      return (statut>='550' && statut<'600');
    } else {
      return false;
    }
  }

  DownloadCreditSafeReport(supplierId:number,compagnyId:string): Observable<any> {
    let getOptions: any = { responseType: 'blob' };
    return this.http.get<any>(`${this.SuppliersUrl}/${supplierId}/CreditSafePdfReport/${compagnyId}`,getOptions);
  }

  addPurchaseComment(commentaire:SupplierPurchaseComment): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${commentaire.SupplierId}/addPurchaseComment`,commentaire);
  }
  delPurchaseComment(supplierId: number,commentaireId:number): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/delPurchaseComment/${commentaireId}`,null);
  }

  UpdateSuiviAchats(supplierId:number,parameters:SuiviAchatsUpdateParameters): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/UpdateSuiviAchats`,parameters);
  }

  /**
   * Recupération des données dépenses d'un fournisseur
   * @param supplierId Identifiant fournisseur
   * @returns tableau de SupplierPilotageDepens
   */
  GetPilotageDepenses(supplierId:number):Observable<SupplierPilotageDepens[]> {
    return this.http.get<SupplierPilotageDepens[]>(`${this.SuppliersUrl}/${supplierId}/PilotageDepenses`);
  }
  
  /**
   * Recherche de l'établissement d'un fournisseur via son n° Siret via l'api du service INSEE
   * @param supplier Identifiant du fournisseur
   * @param autoBindToSupplier En cas de recherche positive, si ce paramète est à true, on écrase les données enregistrées pour le fournisseur par celles renvoyées par l'ip INSEE
   * @returns InseeEtablissement 
   */
  GetSupplierInseeEtablissement(supplier:Supplier,autoBindToSupplier:boolean, updateSignaletique: boolean = true, siret: string = null): Observable<InseeEtablissement> {
    if (!supplier) return of(null);
    let observable :Observable<InseeEtablissement> ;
    if (siret == null) siret = supplier.Siret;
    if (supplier.Etablissement && supplier.Etablissement.siret==siret){
      observable = of(supplier.Etablissement);
    } else if (supplier.Id == 0) {
      observable =  this.intputCheckersSvc.getInseeEtablissement( siret);
    } else {
      observable =  this.intputCheckersSvc.getSupplierInseeEtablissement(supplier.Id, siret);
    }
    return observable
      .pipe(tap((inseeEtab:InseeEtablissement) => {
        if (inseeEtab && autoBindToSupplier) {
          let bindResult: SimpleReponseResult = this.bindInseeEtablissementToSupplier(supplier, inseeEtab, updateSignaletique);
          if (!bindResult.Ok) {
            this.sharedDataSvc.alert(bindResult.Message);
          };
        }
        })
      );
  }

  /**
   * Recupération de l'historique d'accidentologie d'un fournisseur
   * @param supplierId Identifiant fournisseur
   * @returns tableau de SupplierAccHisto
   */
  SupplierAccHistory(supplierId:number) : Observable<SupplierAccHisto[]> {
    return this.http.get<SupplierAccHisto[]>(`${this.SuppliersUrl}/${supplierId}/SupplierAccHistory`);
  }

  /**
   * Envoi du mail de relance Accidentologie
   * @param supplierId Identifiant fournisseur
   * @returns SimpleReponseResult
   */
  RelanceAccidentologie(supplierId:number) : Observable<SimpleReponseResult>{
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/RelanceAccidentologie`,null);
  }

  /**
   * Duplication d'un fournisseur existant avec un nouvel identifiant unique(Siret, TvaIntra ...)
   * @param parameters Paramètres de duplication : Identifiant fournisseur à dupliquer + nouvel identifiant unique + motif de duplication
   * @returns SimpleReponseValue
   */
  DuplicateSupplier(parameters: DuplicateSupplierParameters): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${parameters.SupplierId}/Duplicate`,parameters);
  }

  /**
  * Envoi des éventuels mails alertant les services concernés ou le forunisseur d'un besoin d'intervention: any
  * @param supplierId Identifiant du fournisseur
  * @returns SimpleReponseResult:  Ok = false si problème sur envoi mail.
  * Si Ok=true :
  * Si Message vide, pas d'envoi de mail sinon détail des envois mails effectués
  */
  SendRegulDocsMails(supplierId:number, parameters: SendRegulDocsMailsParameters): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/${supplierId}/SendRegulDocsMails`,parameters);
  }

  UpdateRseAnswers(supplierId:number,supplierRseAnswers: SupplierRseAnswer[]):Observable<SupplierRseAnswer[]>{
    return this.http.post<SupplierRseAnswer[]>(`${this.SuppliersUrl}/${supplierId}/UpdateRseAnswers`,supplierRseAnswers);    
  }

  sendOneRsePendingFile(supplierId:number, answerId:number,  answerIdxId: number,file:File):Observable<SupplierRseAnswersIndex> {
    const formData = new FormData(); 
    formData.append("file", file);
    formData.append("overwriteIfExists", 'true');
    return this.http.post<SupplierRseAnswersIndex>(`${this.SuppliersUrl}/${supplierId}/RseAnswers/${answerId}/answerIndexes/${answerIdxId}/AddFile`, formData);
  }


  RelanceValidationFournisseurs(supplierIds:number[]):Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.SuppliersUrl}/RelanceValidationFournisseurs`, supplierIds);
  }

    public rejectIfSiretInactif(supplier: Supplier) :Promise<SimpleReponseResult> {
       return new Promise<SimpleReponseResult>((resolve, reject) => {
        let ret = new SimpleReponseResult();
        ret.Ok = true;
        if ((supplier?.Siret || '').length != 14){
          resolve && resolve(ret);
          return;
        }
      const inseeEtab: InseeEtablissement = supplier?.Etablissement;
      if (inseeEtab?.isClosed == true && supplier?.StatutId != 13) {
        this.ChangeStatutByCod(supplier.Id, supplier?.StatutId, '910')
          .subscribe((reponse: SimpleReponseResult) => {
            reponse.Message = this.sharedDataSvc.getLoadedLabel('Msg_Fermeture_Etb_Controle_Siret');
            resolve && resolve(reponse);
          });
      } else {
        resolve && resolve(ret);
      }
      });
    }


}
